if (!customElements.get('product-detail-accordion')) {
  customElements.define('product-detail-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.animations = new Map();
      this.querySelectorAll('.oe-product-details__trigger').forEach((button) => {
        const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        const open = button.getAttribute('aria-expanded') === 'true';
        panel.hidden = !open;
        panel.inert = !open;
        panel.style.removeProperty('overflow');
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.oe-product-details__trigger');
        if (button && this.contains(button)) this.setOpen(button, button.getAttribute('aria-expanded') !== 'true');
      }, { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const item = Array.from(this.querySelectorAll('[data-detail-block]')).find((element) => element.dataset.detailBlock === event.detail.blockId);
        if (item && !item.hidden) this.setOpen(item.querySelector('button'), true, false);
      }, { signal });

      // Retain the existing optional variant-specific technical data/downloads.
      this.variantPanels = this.querySelectorAll('[data-jeremias-variant-panel]');
      if (this.variantPanels.length) {
        const register = () => {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          const productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
            if (data?.variant?.id && (!productInfo?.dataset.section || String(data.sectionId) === String(productInfo.dataset.section))) this.updateVariant(data.variant.id);
          });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true, signal });
        else register();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.unsubscribe?.();
      this.animations?.forEach((animation) => animation.cancel());
    }

    setOpen(button, open, animate = true) {
      const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
      if (!panel) return;
      const currentHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      this.animations.get(panel)?.cancel();
      this.animations.delete(panel);
      button.setAttribute('aria-expanded', String(open));
      panel.inert = !open;
      panel.hidden = false;
      panel.style.overflow = 'hidden';
      const targetHeight = open ? panel.scrollHeight : 0;
      const finish = () => {
        panel.hidden = !open;
        panel.style.removeProperty('overflow');
        this.animations.delete(panel);
      };
      if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) {
        finish();
        return;
      }
      const animation = panel.animate([{ height: `${currentHeight}px` }, { height: `${targetHeight}px` }], { duration: 180, easing: 'ease-out' });
      this.animations.set(panel, animation);
      animation.onfinish = finish;
    }

    updateVariant(variantId) {
      let drawingAvailable = false;
      this.variantPanels.forEach((panel) => {
        const selected = panel.dataset.variantId === String(variantId);
        panel.hidden = !selected;
        if (selected && panel.dataset.jeremiasVariantPanel === 'downloads' && panel.dataset.hasDrawing === 'true') drawingAvailable = true;
      });
      const downloads = this.querySelector('[data-jeremias-download-item]');
      if (downloads) {
        const available = drawingAvailable || downloads.dataset.jeremiasGeneralDownloads === 'true';
        if (!available) this.setOpen(downloads.querySelector('button'), false, false);
        downloads.hidden = !available;
      }
    }
  });
}
